exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header__search[data-v-a1afe632]{font-size:16px;font-size:1.6rem}.double-left-nav[data-v-a1afe632]{transform:translate(40px,-51%)}.header--unsubscribe[data-v-a1afe632]{justify-content:flex-start;padding:0 20px}.unsubscribe-ttl a[data-v-a1afe632]{font-family:Montserrat,sans-serif;font-weight:700;color:#ff5b60;font-size:18px;font-size:1.8rem}.pc-nav__link--long[data-v-a1afe632]{width:160px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1afe632","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Header.vue
// module id = 234
// module chunks = 0